import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  root: {
    bgcolor: zeplinColor.BasicBlack,
    padding: '20px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '40px',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    color: zeplinColor.Neutral1,
  },
};
